import { render, staticRenderFns } from "./HomeNew_new.vue?vue&type=template&id=2e5725b8&scoped=true"
import script from "./HomeNew_new.vue?vue&type=script&lang=js"
export * from "./HomeNew_new.vue?vue&type=script&lang=js"
import style0 from "./HomeNew_new.vue?vue&type=style&index=0&id=2e5725b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5725b8",
  null
  
)

export default component.exports